export default __webpack_public_path__ + "static/Dynamique Logo-a8f94dbdbda13377ee35d742af28cbe3.png";